import { useLocation } from "react-router-dom";
import { COMPANY } from "@/lib/content";

// WhatsApp brand colour is #25D366
export default function WhatsAppFAB() {
  const location = useLocation();
  // Hide on admin routes
  if (location.pathname.startsWith("/admin")) return null;

  const number = (COMPANY.whatsapp || "").replace(/[^0-9]/g, "");
  const message = encodeURIComponent(
    "Hello Salihi Group, I would like to learn more about your services."
  );
  const href = `https://wa.me/${number}?text=${message}`;

  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer noopener"
      aria-label="Chat with Salihi Group on WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed z-40 flex items-center justify-center rounded-full shadow-[0_10px_30px_-5px_rgba(37,211,102,0.55)] hover:shadow-[0_14px_40px_-5px_rgba(37,211,102,0.75)] transition-all duration-300 hover:scale-105 active:scale-95"
      style={{
        width: 60,
        height: 60,
        bottom: 96, // clears cookie banner
        right: 24,
        backgroundColor: "#25D366",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        width="32"
        height="32"
        fill="#FFFFFF"
        aria-hidden="true"
      >
        <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.795 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.708.888.545 0 2.192-.732 2.192-1.723 0-.213-.028-.443-.086-.643-.15-.44-1.42-1.245-1.877-1.678zm-2.79 7.264c-1.593 0-3.158-.516-4.437-1.407l-3.098.99 1.005-2.982a7.858 7.858 0 0 1-1.535-4.688c0-4.373 3.633-7.918 8.078-7.918a8.06 8.06 0 0 1 5.696 2.334 7.855 7.855 0 0 1 2.348 5.62c-.006 4.373-3.64 8.05-8.057 8.05zm0-17.585c-5.343 0-9.688 4.267-9.688 9.51 0 1.723.516 3.396 1.32 4.847L6.68 26l4.868-1.55a10.001 10.001 0 0 0 4.834 1.244h.008c5.343 0 9.797-4.267 9.797-9.51 0-2.535-1.06-4.913-2.85-6.698a10.008 10.008 0 0 0-7.016-2.827z" />
      </svg>
    </a>
  );
}
